(function () {
  function getNextPageUrl() {
    var pagination = document.querySelector('.pagination-list');
    if (!pagination) return null;
    var links = pagination.querySelectorAll('a');
    var lastLink = links[links.length - 1];
    if (lastLink && lastLink.textContent.trim() === '>') {
      return lastLink.href;
    }
    return null;
  }

  function createSpinner() {
    var spinner = document.createElement('div');
    spinner.className = 'c-pagination-spinner';
    spinner.innerHTML = '<svg class="c-spinner-svg" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="23" width="2" height="12" rx="1" fill="#C4C4C4"/><rect y="25" width="2" height="12" rx="1" transform="rotate(-90 0 25)" fill="black"/><rect x="12.866" y="45.2842" width="2" height="12" rx="1" transform="rotate(-150 12.866 45.2842)" fill="#2B2B2B"/><rect x="36.866" y="44.2842" width="2" height="12" rx="1" transform="rotate(150 36.866 44.2842)" fill="#575757"/><rect x="45.2847" y="35.1338" width="2" height="12" rx="1" transform="rotate(120 45.2847 35.1338)" fill="#6D6D6D"/><rect x="44.2847" y="11.1338" width="2" height="12" rx="1" transform="rotate(60 44.2847 11.1338)" fill="#989898"/><rect x="25" y="48" width="2" height="12" rx="1" transform="rotate(180 25 48)" fill="#414141"/><rect x="48" y="23" width="2" height="12" rx="1" transform="rotate(90 48 23)" fill="#828282"/><rect x="35.134" y="2.71582" width="2" height="12" rx="1" transform="rotate(30 35.134 2.71582)" fill="#AEAEAE"/><rect x="11.134" y="3.71582" width="2" height="12" rx="1" transform="rotate(-30 11.134 3.71582)" fill="#D9D9D9"/><rect x="2.71533" y="12.8662" width="2" height="12" rx="1" transform="rotate(-60 2.71533 12.8662)" fill="#EFEFEF"/><rect x="3.71533" y="36.8662" width="2" height="12" rx="1" transform="rotate(-120 3.71533 36.8662)" fill="#161616"/></svg>';
    var container = document.querySelector('.cc-collection-products .main-products-grid__results');
    if (container) container.appendChild(spinner);
    return spinner;
  }

  function appendProducts(html) {
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html;

    var newItems = tmpl.content.querySelectorAll('.js-pagination-result');
    var grid = document.querySelector('.cc-collection-products .main-products-grid__results ul[role="list"]');
    if (!grid) return null;

    newItems.forEach(function (item) {
      grid.appendChild(item.cloneNode(true));
    });

    var newPagination = tmpl.content.querySelector('.pagination-list');
    return newPagination;
  }

  function updatePaginationState(newPaginationHtml) {
    var existingPagination = document.querySelector('.pagination-list');
    if (existingPagination && newPaginationHtml) {
      existingPagination.innerHTML = newPaginationHtml.innerHTML;
    } else if (existingPagination && !newPaginationHtml) {
      existingPagination.remove();
    }
  }

  var isFetching = false;

  function fetchNextPage(callback) {
    if (isFetching) return;
    var nextUrl = getNextPageUrl();
    if (!nextUrl) {
      if (callback) callback(false);
      return;
    }

    isFetching = true;

    fetch(nextUrl)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var newPagination = appendProducts(html);
        updatePaginationState(newPagination);

        if (typeof window.initLazyImages === 'function') {
          window.initLazyImages();
        }

        var hasMore = !!getNextPageUrl();
        if (callback) callback(hasMore);
      })
      .catch(function (err) {
        console.error('c-pagination: fetch error', err);
        if (callback) callback(false);
      })
      .finally(function () {
        isFetching = false;
      });
  }

  function initInfiniteScroll() {
    var nextUrl = getNextPageUrl();
    if (!nextUrl) return;

    var spinner = createSpinner();

    var sentinel = document.createElement('div');
    sentinel.className = 'c-infinite-scroll-sentinel';
    var container = document.querySelector('.cc-collection-products .main-products-grid__results');
    if (container) container.appendChild(sentinel);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !isFetching) {
          spinner.style.display = 'flex';

          fetchNextPage(function (hasMore) {
            spinner.style.display = 'none';
            if (!hasMore) {
              observer.disconnect();
              sentinel.remove();
              spinner.remove();
            }
          });
        }
      });
    }, { rootMargin: '600px 0px' });

    observer.observe(sentinel);
  }

  var customPagination = document.querySelector('custom-pagination');
  if (customPagination) {
    customPagination.dataset.pauseInfiniteScroll = 'true';
  }

  initInfiniteScroll();
})();
